import { createSlice } from "@reduxjs/toolkit";
import { SupportedChainId } from "../utils/constant/chains";
import { ConnectionType } from "../utils/constant/connectors";

type AccountProps = {
  selectedWallet?: ConnectionType;
  selectedChainId: number;
};

const initialState: AccountProps = {
  selectedWallet: undefined,
  selectedChainId: SupportedChainId.ARBITRUM_ONE,
};

const accountSlice = createSlice({
  name: "account",
  initialState: initialState,
  reducers: {
    updateSelectedWallet(state, { payload: { wallet } }) {
      state.selectedWallet = wallet;
    },
    updateSelectedChainId(state, { payload: { chainId } }) {
      if ([5, 42161].includes(chainId)) {
        state.selectedChainId = chainId;
      }
    },
  },
});

export const { updateSelectedWallet, updateSelectedChainId } =
  accountSlice.actions;

export default accountSlice.reducer;
